import { usePage } from "@inertiajs/react"
import { PuzzlesIndexProps } from "@/types/types"
import Button from "@/components/Button"
import { PlusIcon } from "@heroicons/react/20/solid"
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline"
import { WP } from "@/components/pieces"
import SearchInput from "./SearchInput"
import Pagination from "./Pagination"
import SortingSelector from "./SortingSelector"
import PuzzleItem from "@/components/puzzle/PuzzleItem"
import useCreatePuzzle from "@/hooks/useCreatePuzzle"

const PuzzlesList = () => {
  const { createPuzzle, processing } = useCreatePuzzle()

  const { puzzles, filters } = usePage<PuzzlesIndexProps>().props
  const search = filters.search || ""

  const hasNoPuzzles = !search && puzzles.length === 0

  return (
    <div className="flex flex-1 flex-col pt-6">
      {hasNoPuzzles ? (
        <div className="padding mx-auto flex max-w-xs flex-col items-center justify-center py-10">
          <div className="flex items-center justify-center rounded-xl bg-gray-200 p-3">
            <WP className="size-6 text-gray-500" />
          </div>
          <h3 className="my-4 text-center text-base leading-6 font-semibold text-gray-900">
            Create your first puzzle
          </h3>
          <Button size="sm" loading={processing} onClick={createPuzzle}>
            <PlusIcon className="size-5" />
            <span>Add puzzle</span>
          </Button>
        </div>
      ) : (
        <>
          <div className="padding relative flex flex-col items-start justify-start gap-x-8 gap-y-4 sm:flex-row sm:items-center">
            <SearchInput />
            <SortingSelector type="puzzles" />
          </div>

          <div className="relative mt-6 flex flex-1 flex-col">
            {puzzles && puzzles.length > 0 ? (
              <>
                <ul
                  role="list"
                  className="divide-y divide-gray-200 border-y border-gray-200"
                >
                  {puzzles.map((puzzle) => (
                    <PuzzleItem key={puzzle.id} {...puzzle} />
                  ))}
                </ul>

                <div className="flex-1" />

                <Pagination type="puzzle" />
              </>
            ) : (
              <div className="padding mx-auto flex max-w-xs flex-col items-center justify-center py-10">
                <div className="flex items-center justify-center rounded-xl bg-gray-200 p-3">
                  <MagnifyingGlassIcon className="size-6 text-gray-500" />
                </div>
                <h3 className="mt-4 text-center text-base leading-6 font-semibold text-gray-900">
                  No puzzles found.
                </h3>
                <p className="text-center text-sm text-gray-700">
                  &ldquo;{search}&rdquo; did not match the title of any puzzle.
                </p>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default PuzzlesList
